import React from 'react';
import cx from 'clsx';

import styles from './Layout.module.scss';
import config from '../../config';
import DeviceProvider from '../DeviceProvider';
import { DeviceOs } from '../../logic/main/types';

interface LayoutPropTypes {
  children?: React.ReactNode;
  isNavigationVisible?: boolean;
  isFooterVisible?: boolean;
  deviceType: 'mobile' | 'tablet' | 'desktop';
  deviceOs: DeviceOs;
}

const Layout: React.FC<LayoutPropTypes> = ({
  children,
  deviceType,
  deviceOs,
}) => {
  const mode = config.staticComponents['Layout']?.mode || 'default';
  return (
    <DeviceProvider deviceType={deviceType} deviceOs={deviceOs}>
      <div
        className={cx(styles.layout, {
          [styles.layoutWithNavigation]: mode === 'small',
          [styles.layoutWithFooter]: mode === 'small',
        })}
        data-testid="layout"
      >
        <div
          className={cx(styles.content, {
            [styles.contentResponsive]: mode === 'default',
            [styles.contentStatic]: mode !== 'default',
          })}
          data-testid="page-content"
          id="page-content"
        >
          {children}
        </div>
      </div>
    </DeviceProvider>
  );
};

export default Layout;
